export class ServerError extends Error {
  status: number;

  constructor(status: number) {
    super('ServerError');
    this.name = 'ServerError';
    this.status = status;

    Object.setPrototypeOf(this, ServerError.prototype);
  }
}
